// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"chart-scatter"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 21H3V3","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"g","attrs":{"id":"stroke2"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M19 7C18.4477 7 18 6.55228 18 6C18 5.44772 18.4477 5 19 5C19.5523 5 20 5.44772 20 6C20 6.55228 19.5523 7 19 7Z M11.998 6H12.002V6.00391H11.998V6Z M6.99805 9H7.00195V9.00391H6.99805V9Z M11 14C10.4477 14 10 13.5523 10 13C10 12.4477 10.4477 12 11 12C11.5523 12 12 12.4477 12 13C12 13.5523 11.5523 14 11 14Z M15.998 11H16.002V11.0039H15.998V11Z M17.998 16H18.002V16.0039H17.998V16Z M6.99805 17H7.00195V17.0039H6.99805V17Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]}]};

const ChartScatterIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chart-scatter',
    ref,
    icon: element,
  },
));

ChartScatterIcon.displayName = 'ChartScatterIcon';

export default ChartScatterIcon;
